/* Variant picker + add-to-cart. Scoped per [data-product-form]. */
(function () {
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = parts[0];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDecimals.replace('.', ',').replace(/,(?=\d{3})/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals.replace(/,/g, '.'));
  }
  window.theme = window.theme || {};
  window.theme.formatMoney = formatMoney;

  function initForm(root) {
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) { return; }
    var scope = root.closest('[data-product-section]') || root;
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addLabel = root.querySelector('[data-add-label]');
    var stockSlot = root.querySelector('[data-stock-slot]');
    var priceEl = scope.querySelector('[data-price]');
    var compareEl = scope.querySelector('[data-compare]');
    var badgeEl = scope.querySelector('[data-sale-badge]');
    var imageEl = scope.querySelector('.pdp__main');
    var isMain = root.hasAttribute('data-main-product');
    var sticky = isMain ? scope.querySelector('[data-sticky-atc]') : null;
    var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
    var stickyBtn = sticky && sticky.querySelector('[data-sticky-add]');

    var gallery = scope.querySelector('[data-gallery]');
    var frames = gallery ? gallery.querySelectorAll('[data-frame]') : [];
    var track = gallery ? gallery.querySelector('[data-frames]') : null;
    var isStack = !!(gallery && gallery.hasAttribute('data-gallery-stack'));
    var pdp = scope.querySelector('[data-pdp]');
    var desktop = window.matchMedia('(min-width: 901px)');

    function markActive(imageId) {
      if (!gallery) return;
      gallery.setAttribute('data-main-id', imageId);
      gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', String(t.getAttribute('data-image-id')) === String(imageId));
      });
      frames.forEach(function (f) {
        f.classList.toggle('is-active', String(f.getAttribute('data-image-id')) === String(imageId));
      });
    }
    // Stage mode (homepage): swap the single image. Stack mode: scroll the matching frame into view.
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function scrollBehavior(silent) { return (silent || reduceMotion.matches || document.visibilityState === 'hidden') ? 'auto' : 'smooth'; }
    function setImage(src, imageId, opts) {
      opts = opts || {};
      if (!imageId && !src) return;
      if (isStack) {
        var frame = null;
        frames.forEach(function (f) { if (String(f.getAttribute('data-image-id')) === String(imageId)) frame = f; });
        markActive(imageId);
        if (!frame) return;
        if (desktop.matches) {
          if (!opts.silent) frame.scrollIntoView({ block: 'nearest', behavior: scrollBehavior(false) });
        } else if (track) {
          track.scrollTo({ left: frame.offsetLeft, behavior: scrollBehavior(opts.silent) });
        }
        return;
      }
      if (!imageEl) return;
      imageEl.removeAttribute('srcset');
      imageEl.removeAttribute('sizes');
      if (src) imageEl.src = src;
      markActive(imageId);
    }
    if (gallery) {
      gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.addEventListener('click', function () { setImage(t.getAttribute('data-src'), t.getAttribute('data-image-id')); });
      });
    }
    if (isStack && track && frames.length) {
      // Phones: keep the active thumb in sync with swipes.
      if ('IntersectionObserver' in window) {
        var swipeIO = new IntersectionObserver(function (entries) {
          if (desktop.matches) return;
          entries.forEach(function (e) { if (e.isIntersecting) markActive(e.target.getAttribute('data-image-id')); });
        }, { root: track, threshold: 0.6 });
        frames.forEach(function (f) { swipeIO.observe(f); });
      }
      // Desktop: stick whichever column is shorter than the viewport; let a long buy panel scroll internally.
      function layoutStack() {
        if (!pdp) return;
        if (!desktop.matches) { pdp.classList.remove('media-sticky', 'info-scroll'); return; }
        var info = scope.querySelector('.pdp__info');
        var mediaH = track.scrollHeight;
        var infoH = info ? info.scrollHeight : 0;
        var vh = window.innerHeight;
        var mediaSticky = mediaH <= vh && mediaH < infoH;
        pdp.classList.toggle('media-sticky', mediaSticky);
        pdp.classList.toggle('info-scroll', !mediaSticky && infoH > vh);
      }
      layoutStack();
      window.addEventListener('resize', layoutStack);
      frames.forEach(function (f) { var im = f.querySelector('img'); if (im && !im.complete) im.addEventListener('load', layoutStack); });
      if (frames.length === 1) gallery.classList.add('is-single');
      // Start on the selected variant's image without animating.
      var initial = gallery.getAttribute('data-main-id');
      if (initial) setImage(null, initial, { silent: true });
    }

    function selectedOptions() {
      var groups = root.querySelectorAll('[data-option-index]');
      var opts = [];
      groups.forEach(function (g) {
        var sel = g.querySelector('.variant__opt.is-selected');
        opts.push(sel ? sel.getAttribute('data-option-value') : null);
      });
      return opts;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(v) {
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = (window.theme.strings && window.theme.strings.unavailable) || 'UNAVAILABLE';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (badgeEl) badgeEl.hidden = !(v.compare_at_price > v.price);
      if (stockSlot) stockSlot.textContent = v.stock || '';
      var buyRow = root.querySelector('.buy-row');
      if (buyRow) buyRow.classList.toggle('is-soldout', !v.available);
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.innerHTML = v.available ? 'ADD TO CART — <span data-add-price>' + formatMoney(v.price) + '</span>' : ((window.theme.strings && window.theme.strings.soldOut) || 'SOLD OUT');
      }
      if ((imageEl || isStack) && v.image_id) setImage(v.image, v.image_id);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'ADD TO CART' : ((window.theme.strings && window.theme.strings.soldOut) || 'SOLD OUT'); }
      root.querySelectorAll('[data-option-index]').forEach(function (g) {
        var cur = g.querySelector('[data-option-current]');
        var sel = g.querySelector('.variant__opt.is-selected');
        if (cur && sel) cur.textContent = '· ' + sel.getAttribute('data-option-value');
      });
      if (isMain && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('.variant__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('.variant__opt').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
        render(findVariant(selectedOptions()));
      });
    });

    var qtyWrap = root.querySelector('[data-qty]');
    if (qtyWrap) {
      var qi = qtyWrap.querySelector('[data-qty-input]');
      qtyWrap.querySelector('[data-qty-dec]').addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); });
      qtyWrap.querySelector('[data-qty-inc]').addEventListener('click', function () { qi.value = (parseInt(qi.value, 10) || 1) + 1; });
    }

    var form = root.querySelector('form[data-product-form-el]');
    if (form && sticky && addBtn && 'IntersectionObserver' in window) {
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-atc', past);
      }, { threshold: 0 });
      io.observe(addBtn);
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var errEl = root.querySelector('[data-form-error]');
        if (errEl) errEl.hidden = true;
        var id = idInput ? idInput.value : null;
        if (!id) return;
        if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); }
        var qtyInput = root.querySelector('[data-qty-input]');
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        window.theme.cart.add(id, qty).then(function () {
          if (addBtn) addBtn.removeAttribute('aria-busy');
        }).catch(function (err) {
          if (addBtn) addBtn.removeAttribute('aria-busy');
          if (errEl) { errEl.textContent = (err && err.message) || 'Could not add to cart.'; errEl.hidden = false; }
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-product-form]').forEach(function (r) {
      if (r.__inited) return; r.__inited = true; initForm(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
